import script from "./RowActionDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./RowActionDropdown.vue?vue&type=script&setup=true&lang=js"

import "./RowActionDropdown.vue?vue&type=style&index=0&id=3e629d5c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e629d5c"]])

export default __exports__